import React, { useContext } from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useNavigate } from "react-router-dom";
import { Context } from "../../context/ContextProvider";

const Img = styled("img")({
  margin: "auto",
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
});

export default function CartItemM({ item, addToCart, removeFromCart }) {
  let navigate = useNavigate();
  const {
    categories,
    items,
    setItems,
    addOrder,
    setOrders,
    orders,
    newList,
    setNewList,
    amountOfItemsInCart,
    handleAddProduct,
    cartItmes,
    setCartItems,
    handleRemoveProduct,
    totalPrice,
  } = useContext(Context);


  return (
    <Paper
      sx={{
        p: 1,
        margin: "auto",
        m: 2,
        // maxWidth: 500,
        flexGrow: 1,
        backgroundColor: (theme) =>
          theme.palette.mode === "dark" ? "#1A2027" : "#fff",
      }}
    >
      <Grid container justifyContent="center" >
        <Grid item>
          <ButtonBase sx={{ width: 100, height: 100 }}>
            <Img
              alt="complex"
              src={item.image.includes(",")
              ? item.image.split(",")[0]
              : item.image}
            />
          </ButtonBase>
        </Grid>
        <Grid item xs={8} sm container>
          <Grid item xs container direction="column">
            <Grid item xs>
              <Typography pt={2.5} variant="subtitle1" component="div">
                {item.name}
              </Typography>
              {/* <Typography variant="body2" gutterBottom>
                Full resolution 1920x1080 • JPEG
              </Typography>
              <Typography variant="body2" color="text.secondary">
                ID: 1030114
              </Typography> */}
            </Grid>
            {/* <Grid item>
              <Typography sx={{ cursor: "pointer" }} variant="body2">
                Remove
              </Typography>
            </Grid> */}
            {/* <ButtonGroup
                // style={{ backgroundColor:"yellow" }}
                disableElevation
                variant="contained"
                aria-label="Disabled elevation buttons"
              > */}
          </Grid>
          <Grid item>
            {/* <Typography variant="subtitle1" component="div">
              {item.price} ريال
            </Typography> */}
            <div
              style={{ display: "flex", backgroundColor: "red", marginTop: 20 }}
            >
              {/* <Button
                style={{
                  maxWidth: 10,
                  // margin: 3,
                  // borderRadius: 5,
                  // backgroundColor: "green",
                }}
                onClick={() => addToCart(item)}
              >
                +
              </Button>
              <Typography
                style={{
                  // margin: 10,
                  backgroundColor: "white",
                  paddingTop: 7,
                }}
              >
                {item.quantity}
              </Typography>
              <Button
                style={{ maxWidth: 10 }}
                onClick={() => removeFromCart(item)}
              >
                -
              </Button> */}
            </div>

            <Box
              display="flex"
              // alignItems="right"
              mb="5px"
              // pr="25px"
              // border={`1.5px solid #e2e1e1`}
              mr="20px"
              // p="2px 5px 0 10px"
              // bgcolor={"red"}
            >
            <Typography  variant="subtitle1" >
              {item.unit.toFixed(2)} ريال
            </Typography>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              border={`1.5px solid #e2e1e1`}
              mr="20px"
              p="2px 5px"
            >
              <IconButton onClick={() => addToCart(item)}>
                <AddIcon />
              </IconButton>
              <Typography sx={{ p: "0 5px" }}>{item.qty}</Typography>
              <IconButton
                onClick={() => {
                  removeFromCart(item);
                  
                }}
              >
                <RemoveIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
